import { useState, useEffect } from "react";
import { InputAdornment } from "@mui/material";
import { withPather } from "react-pather";
import MainInput from "./MainInput";
import WebsiteFavicon from "../../WebsiteFavicon";

const URLInput = ({
  pather,
  url,
  setUrl,
  placeholder = "https://your-long-url.com",
  hideFavicon = false,
  endAdornment = null,
  onKeyDown = null,
}) => {
  const [showIcon, setShowIcon] = useState(false);

  useEffect(() => {
    if (url && pather.isURLValid(url.trim(), true)) {
      setShowIcon(true);
    }
  }, []);

  let InputProps = {
    startAdornment:
      url && showIcon && !hideFavicon ? (
        <InputAdornment
          position="start"
          sx={{
            alignSelf: "flex-start",
            mt: 1.5,
          }}
        >
          <WebsiteFavicon url={url} />
        </InputAdornment>
      ) : null,
  };

  if (endAdornment) InputProps.endAdornment = endAdornment;

  return (
    <MainInput
      placeholder={placeholder}
      value={url}
      onChange={(e) => setUrl(e.target.value.trim())}
      onBlur={() => setShowIcon(true)}
      onFocus={() => setShowIcon(false)}
      onKeyDown={onKeyDown}
      InputProps={InputProps}
    />
  );
};

export default withPather()(URLInput);
